import {push} from 'react-router-redux';
import _ from 'lodash';
import CHATED from '../../../helpers/chated-client';
import {
	DOWNLOAD_CUSTOMER_EMAIL_EVENT,
	GET_SHOPIFY_APP_CONNECTION,
	ERROR_DOWNLOAD_CUSTOMER_EMAIL_EVENT,
	ERROR_GET_SHOPIFY_APP_CONNECTION
} from '../../../constants';

export function downloadCustomerEmailEvents(page, limit) {
	return async (dispatch) => {
		const response = await CHATED.customerEmailEvent.getAll({
			page,
			limit
		});

		if (response.meta.code !== 200) {
			dispatch({
				type: ERROR_DOWNLOAD_CUSTOMER_EMAIL_EVENT,
				meta: response.meta
			});

			return;
		}

		dispatch({
			type: DOWNLOAD_CUSTOMER_EMAIL_EVENT,
			customer_email_events: response.data.customer_email_events,
			count: response.data.count
		});
	};
}

export function getShopifyAppConnection() {
	return async (dispatch) => {
		const response = await CHATED.appConnection.getAll({});

		if (response.meta.code !== 200) {
			dispatch({
				type: ERROR_GET_SHOPIFY_APP_CONNECTION,
				meta: response.meta
			});
			return;
		}

		const appConnection = _.find(response.data.app_connections, function(appConnection) {
			return appConnection.app_slug === 'bigcommerce' || appConnection.app_slug === 'shopify';
		});

		if (_.isNil(appConnection) || !appConnection.token_valid) {
			dispatch(push('/'));
		} else {
			dispatch({
				type: GET_SHOPIFY_APP_CONNECTION,
				meta: response.meta,
				app_connection: appConnection
			});
		}
	};
}



// WEBPACK FOOTER //
// ./src/containers/dashboard-emails-activity-page/actions/index.js